module.exports = __webpack_public_path__ + "img/slide_2.6c1de9ff.jpg";